import axios from 'axios'
var retryCount = 0,
    hlsPlayer = null,
    clearTimeSet = null

// 关闭拉流
function stopHLSPlayIfNeeded() {
    if (hlsPlayer) {
        hlsPlayer.stop()
        hlsPlayer = null
    }
}
// 停止重连任务
function stopRetryTaskIfNeeded() {
    if (clearTimeSet) {
        clearTimeout(clearTimeSet)
        clearTimeSet = null
        retryCount = 0
    }
}

// 初始化视频
function mxVideoInit(clearTimeSet) {
    stopHLSPlayIfNeeded(hlsPlayer)
    stopRetryTaskIfNeeded(clearTimeSet)
}
// 传入地址 开启暂停播放
function startHLSPlay(that, url, ref) {
    ref.src = url
    ref.muted = false
    setTimeout(() => {
        hlsPlayer = createEZUIPlayer()
    }, 100);
}

// 拉流
function shakeHand(that, hlsUrl, ref, direct = false) {
    if (direct) {
        mxVideoInit(hlsPlayer, clearTimeSet)
        startHLSPlay(that, hlsUrl, ref)
        that.monitor_showloding_flag = false
    } else {
        axios
            .get(hlsUrl, {
                params: {},
            })
            .then(function(res) {
                if (res) {
                    // stopHLSPlayIfNeeded()
                    mxVideoInit(hlsPlayer, clearTimeSet)
                    startHLSPlay(that, hlsUrl, ref)
                } else {
                    that.$Message.info('流地址加载失败1')
                }
                that.monitor_showloding_flag = false
            })
            .catch(function(error) {
                if (retryCount < 10) {
                    clearTimeSet = setTimeout(() => {
                        retryCount++
                        console.log('重连:' + retryCount + '次')
                        shakeHand(that, hlsUrl, ref)
                    }, 1000)
                } else {
                    // stopRetryTaskIfNeeded()
                    mxVideoInit(hlsPlayer, clearTimeSet)
                    that.$Message.info('流地址加载失败2')
                }
                that.monitor_showloding_flag = false
            })
    }

}

function createEZUIPlayer() {
    var player = new EZUIPlayer('myPlayer')
    player.on('error', function() {
        console.log('error');
    })
    player.on('play', function() {
        console.log('play', '播放')
    })
    player.on('pause', function() {
        console.log('pause', '暂停')
    })
    player.on('abort', function(e) {
        console.log('abort' + e);
    })
    return player
}



export { stopHLSPlayIfNeeded, stopRetryTaskIfNeeded, shakeHand, createEZUIPlayer, mxVideoInit }